export default "__VITE_ASSET__CNzuoa7s__"